import React from 'react';
/** Presentational component for displaying upload progress */
export class TranscribeUploadingView extends React.Component {
    render() {
        const progress = Math.floor(this.props.percentCompleted * 100);
        const uploadingStyle = { width: `${progress}%` };
        return (React.createElement("div", { id: "transcribe-button-uploading", className: "transcribe-button relative overflow-hidden" },
            React.createElement("div", { className: "progress-bar absolute h-100", style: uploadingStyle }),
            React.createElement("div", { className: "w-100 ttu tracked center fw6 relative z-1" }, "UPLOADING...")));
    }
}
